import {DialogViewActionWidget,SPI,ActionWidget, ActionType, Condition} from '@kunlun/dependencies';
@SPI.ClassFactory(
    ActionWidget.Token({
        actionType: ActionType.View,
        name: "uiClient520095053212606119-169873096382308234Jq2",
        model: 'deli.aries.seller.DeliAriesSellerPaperItem'
    })
)
export class AriesCoreSeller extends DialogViewActionWidget { 
 protected async clickAction(): Promise<void> {
    const ids = this.dataSource?.map((v) => v.id) as string[];
    if (ids?.length) {
        const condition = new Condition('id').notIn(ids);
        this.action.filter = condition.toString();
      } else {
        this.action.filter = '';
      }
      await super.clickAction();
      return;
 }
}